/**
 * tokenStore — in-memory holder for the current session JWT.
 *
 * Replaces the v143-era `localStorage.getItem('ve_token')` pattern.
 *
 * Why in-memory and not localStorage?
 *   localStorage is JS-readable, so any XSS payload on the page can
 *   exfiltrate the token. Storing the JWT in memory only — plus the
 *   primary HttpOnly `session_token` cookie set by the backend — means:
 *     1. The cookie does the actual auth (HttpOnly = JS cannot read it).
 *     2. The in-memory token is just a fallback for places that can't
 *        send a cookie:
 *          (a) Authorization: Bearer header for axios/fetch — useful
 *              if a future cross-origin call needs explicit token send,
 *          (b) WebSocket `?token=` query param fallback,
 *          (c) `<a href="...?auth=...">` download links when the cookie
 *              can't ride a cross-origin GET. (For same-origin downloads
 *              we now omit `?auth=` entirely — cookie rides automatically.)
 *
 * On page reload the in-memory store is empty, but the cookie persists
 * (Max-Age=7d). AuthContext.checkAuth() calls /api/auth/me with
 * `credentials: 'include'` → backend reads the cookie → 200 + user payload.
 * No interruption to the user; just no Bearer fallback until the next sign-in.
 */
let _token = null;

export function setToken(token) {
  _token = token || null;
}

export function getToken() {
  return _token;
}

export function clearToken() {
  _token = null;
}

export function hasToken() {
  return !!_token;
}
